<h2 class="title is-3" i18n>Update token scope</h2>

<portal-token-scope-form
  [tokenScope]="tokenScope"
  [disabled]="saving"
  (formValidated)="onFormValidated($event)"
  (canceled)="onClose()"
></portal-token-scope-form>
